import { message } from 'antd';

message.config({
  maxCount: 3,
});

/** @deprecated import message from bb/elements-web instead */
export default message;
